/* Thread Mug side cart — line controls (2026-10-02).
   The unified drawer (sections/mini_cart.liquid) is re-rendered from the Section Rendering API,
   so we own its line controls with one delegated, capture-phase listener:
   qty +/- (debounced), minus-at-minimum and trash = remove (animated, with Undo).
   Uses the line item KEY (data-id on the quantity input / remove link). */
(function () {
  'use strict';
  if (window.TMCartLines) return;

  var DRAWER_ID = 't4s-mini_cart';
  var SECTION_ID = 'mini_cart';
  var reduceMotion = false;
  try { reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}

  function root() {
    var r = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return r.charAt(r.length - 1) === '/' ? r : r + '/';
  }
  function drawer() { return document.getElementById(DRAWER_ID); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function shortTitle(t) {
    t = String(t || '').replace(/\s+/g, ' ').trim();
    var cut = t.length;
    var c = t.indexOf(',');
    var p = t.indexOf(' | ');
    if (c > 0) cut = Math.min(cut, c);
    if (p > 0) cut = Math.min(cut, p);
    return t.slice(0, cut).trim() || t;
  }

  (function injectStyle() {
    if (document.getElementById('tm-cl-style')) return;
    var st = document.createElement('style');
    st.id = 'tm-cl-style';
    st.textContent =
      '#' + DRAWER_ID + ' .t4s-mini_cart__item.tm-cl-busy{opacity:.6;pointer-events:none;transition:opacity .15s ease}' +
      '#' + DRAWER_ID + ' .t4s-mini_cart__item.tm-cl-out{transform:translateX(16px);opacity:0;transition:transform .22s ease,opacity .22s ease;pointer-events:none}' +
      '#' + DRAWER_ID + ' .t4s-mini_cart__item.tm-cl-collapse{overflow:hidden;transition:height .2s ease,margin .2s ease,padding .2s ease}' +
      '.tm-cl-undo{display:flex;align-items:center;justify-content:space-between;gap:10px;margin:6px 0;padding:10px 12px;border-radius:8px;background:#f6f2ec;font-family:"DM Sans","Helvetica Neue",Arial,sans-serif;font-size:13px;line-height:1.35;color:#333;transition:opacity .2s ease}' +
      '.tm-cl-undo__txt{min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}' +
      '.tm-cl-undo button{flex:0 0 auto;margin:0;padding:0!important;min-height:0!important;border:0!important;background:none!important;color:#111!important;font:inherit;font-weight:600;text-decoration:underline;text-underline-offset:2px;cursor:pointer}' +
      '.tm-cl-error{margin:6px 0 0;font-family:"DM Sans","Helvetica Neue",Arial,sans-serif;font-size:12.5px;color:#b42318}' +
      '@media (prefers-reduced-motion: reduce){#' + DRAWER_ID + ' .t4s-mini_cart__item.tm-cl-out{transform:none}}';
    (document.head || document.documentElement).appendChild(st);
  })();

  /* ---------- requests (serialised so Shopify sees changes in order) ---------- */
  var queue = Promise.resolve();
  function enqueue(fn) {
    var p = queue.then(fn, fn);
    queue = p.catch(function () {});
    return p;
  }
  function postJSON(url, body) {
    return fetch(root() + url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (res) {
      return res.json().catch(function () { return {}; }).then(function (data) {
        if (!res.ok) {
          var err = new Error((data && (data.description || data.message)) || 'Request failed');
          err.status = res.status;
          throw err;
        }
        return data;
      });
    });
  }
  function getCart() {
    return fetch(root() + 'cart.js', { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }

  /* ---------- header badges ---------- */
  function updateCounts(cart) {
    if (!cart || cart.item_count == null) return;
    var n = Number(cart.item_count) || 0;
    document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = n; });
    var html = document.documentElement;
    html.className = html.className.replace(/\bt4s-cart-count-\d+\b/, 't4s-cart-count-' + n);
    var d = drawer();
    if (d) d.setAttribute('data-ccount', n);
  }

  /* ---------- drawer refresh: swap line list + heading/totals only ---------- */
  function fetchSection() {
    return fetch(root() + '?sections=' + SECTION_ID, { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        var html = data && data[SECTION_ID];
        if (!html || typeof html !== 'string') return null;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var wrap = doc.getElementById('shopify-section-' + SECTION_ID) || doc.body;
        return wrap && wrap.querySelector('.t4s-drawer__header') ? wrap : null;
      })
      .catch(function () { return null; });
  }

  function refreshDrawer(cart) {
    return fetchSection().then(function (fresh) {
      var d = drawer();
      if (!d || !fresh) return;
      var count = cart && cart.item_count != null ? Number(cart.item_count) : (fresh.querySelector('[data-cart-item]') ? 1 : 0);
      var items = d.querySelector('[data-cart-items]');
      var freshItems = fresh.querySelector('[data-cart-items]');
      if (count === 0 || !items || !freshItems || !fresh.querySelector('[data-cart-item]')) {
        /* empty (or structure changed): normal full render, which shows the drawer's empty state.
           tm-added-panel.js re-applies the green "Added" strip on its own if that mode is on. */
        var host = null;
        for (var i = 0; i < d.children.length; i++) {
          if (d.children[i].classList.contains('shopify-section')) host = d.children[i];
        }
        (host || d).innerHTML = fresh.innerHTML;
        return;
      }
      var scroll = d.querySelector('[data-t4s-scroll-me]');
      var top = scroll ? scroll.scrollTop : 0;
      /* keep any Undo rows where they are */
      var undos = [];
      Array.prototype.forEach.call(items.querySelectorAll('.tm-cl-undo'), function (u) {
        var idx = 0;
        var n = u.previousElementSibling;
        while (n) { if (n.matches('[data-cart-item]')) idx++; n = n.previousElementSibling; }
        undos.push({ el: u, idx: idx });
      });
      items.innerHTML = freshItems.innerHTML;
      undos.forEach(function (u) {
        var rows = items.querySelectorAll('[data-cart-item]');
        var ref = rows[u.idx] || null;
        items.insertBefore(u.el, ref);
      });
      d.querySelectorAll('[data-tm-mc-sync]').forEach(function (el) {
        var f = fresh.querySelector('[data-tm-mc-sync="' + el.getAttribute('data-tm-mc-sync') + '"]');
        if (f && f.innerHTML !== el.innerHTML) el.innerHTML = f.innerHTML;
      });
      /* the applied code as the server renders it now (same input, value only) */
      var dc = d.querySelector('input[data-cart-discount]');
      var fdc = fresh.querySelector('input[data-cart-discount]');
      if (dc && fdc && dc.value !== fdc.value) dc.value = fdc.value;
      if (scroll) scroll.scrollTop = top;
      try { if (window.TMDelivery && typeof window.TMDelivery.refresh === 'function') window.TMDelivery.refresh(d); } catch (e) {}
    });
  }

  /* ---------- row helpers ---------- */
  function rowKey(row) {
    var el = row.querySelector('[data-cart-remove][data-id]') || row.querySelector('input[data-action-change][data-id]');
    return el ? el.getAttribute('data-id') : '';
  }
  function rowTitle(row) {
    var t = row.querySelector('.t4s-mini_cart__title');
    return shortTitle(t ? t.textContent : '');
  }
  function showError(row, msg) {
    if (!row) return;
    var old = row.querySelector('.tm-cl-error');
    if (old) old.parentNode.removeChild(old);
    var p = document.createElement('p');
    p.className = 'tm-cl-error';
    p.setAttribute('role', 'alert');
    p.textContent = msg || "Couldn't update. Please try again";
    (row.querySelector('.t4s-mini_cart__info') || row).appendChild(p);
    setTimeout(function () { if (p.parentNode) p.parentNode.removeChild(p); }, 4000);
  }
  function wait(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }

  function animateOut(row) {
    if (reduceMotion) {
      row.classList.add('tm-cl-out');
      return wait(160).then(function () { row.style.display = 'none'; });
    }
    row.classList.add('tm-cl-out');
    return wait(220).then(function () {
      var h = row.getBoundingClientRect().height;
      row.style.height = h + 'px';
      row.classList.add('tm-cl-collapse');
      void row.offsetHeight;
      row.style.height = '0px';
      row.style.marginTop = '0px';
      row.style.marginBottom = '0px';
      row.style.paddingTop = '0px';
      row.style.paddingBottom = '0px';
      return wait(200);
    }).then(function () { row.style.display = 'none'; });
  }
  function restoreRow(row) {
    row.classList.remove('tm-cl-out', 'tm-cl-collapse', 'tm-cl-busy');
    ['height', 'marginTop', 'marginBottom', 'paddingTop', 'paddingBottom', 'display'].forEach(function (p) { row.style[p] = ''; });
  }

  /* ---------- remove (minus at minimum / trash) ---------- */
  function removeRow(row) {
    if (!row || row.getAttribute('data-tm-cl-removing')) return;
    var key = rowKey(row);
    if (!key) return;
    row.setAttribute('data-tm-cl-removing', '1');
    var title = rowTitle(row);
    var snapshot = null;
    var anim = animateOut(row);
    var req = enqueue(function () {
      return getCart().then(function (cart) {
        if (cart && cart.items) {
          for (var i = 0; i < cart.items.length; i++) {
            if (cart.items[i].key === key) { snapshot = cart.items[i]; break; }
          }
        }
        return postJSON('cart/change.js', { id: key, quantity: 0 });
      });
    });
    Promise.all([anim, req]).then(function (res) {
      var cart = res[1];
      updateCounts(cart);
      var undo = null;
      if (snapshot && cart && cart.item_count > 0) undo = undoRow(row, title, snapshot);
      else if (row.parentNode) row.parentNode.removeChild(row);
      if (undo && row.parentNode) row.parentNode.removeChild(row);
      return refreshDrawer(cart);
    }).catch(function () {
      anim.then(function () {
        row.removeAttribute('data-tm-cl-removing');
        restoreRow(row);
        showError(row);
      });
    });
  }

  function undoRow(row, title, item) {
    var u = document.createElement('div');
    u.className = 'tm-cl-undo';
    u.setAttribute('role', 'status');
    u.innerHTML = '<span class="tm-cl-undo__txt">Removed ' + esc(title) + '</span><button type="button" data-tm-cl-undo>Undo</button>';
    row.parentNode.insertBefore(u, row);
    var timer = setTimeout(function () { dropUndo(u); }, 5000);
    u.querySelector('[data-tm-cl-undo]').addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      clearTimeout(timer);
      var btn = e.currentTarget;
      btn.disabled = true;
      var line = { id: item.variant_id, quantity: item.quantity || 1 };
      if (item.properties && Object.keys(item.properties).length) line.properties = item.properties;
      if (item.selling_plan_allocation && item.selling_plan_allocation.selling_plan) line.selling_plan = item.selling_plan_allocation.selling_plan.id;
      enqueue(function () { return postJSON('cart/add.js', { items: [line] }); })
        .then(function () { return getCart(); })
        .then(function (cart) {
          updateCounts(cart);
          if (u.parentNode) u.parentNode.removeChild(u);
          return refreshDrawer(cart);
        })
        .catch(function () {
          btn.disabled = false;
          u.querySelector('.tm-cl-undo__txt').textContent = "Couldn't update. Please try again";
          timer = setTimeout(function () { dropUndo(u); }, 5000);
        });
    });
    return u;
  }
  function dropUndo(u) {
    if (!u.parentNode) return;
    u.style.opacity = '0';
    setTimeout(function () { if (u.parentNode) u.parentNode.removeChild(u); }, 220);
  }

  /* ---------- quantity (+/-, typed), debounced per line ---------- */
  var pending = {};
  function setQty(row, input, qty) {
    var key = rowKey(row);
    if (!key) return;
    var min = parseInt(input.getAttribute('min'), 10);
    if (!(min > 0)) min = 1;
    var max = parseInt(input.getAttribute('max'), 10) || 9999;
    if (qty < min) { removeRow(row); return; }
    if (qty > max) qty = max;
    input.value = String(qty);
    clearTimeout(pending[key]);
    pending[key] = setTimeout(function () {
      delete pending[key];
      var prev = parseInt(input.getAttribute('data-current-qty'), 10) || 1;
      if (qty === prev) return;
      row.classList.add('tm-cl-busy');
      enqueue(function () { return postJSON('cart/change.js', { id: key, quantity: qty }); })
        .then(function (cart) {
          updateCounts(cart);
          return refreshDrawer(cart);
        })
        .catch(function (err) {
          row.classList.remove('tm-cl-busy');
          input.value = String(prev);
          showError(row, err && err.status === 422 && err.message && err.message !== 'Request failed' ? err.message : null);
        });
    }, 300);
  }

  function inDrawer(el) {
    var d = drawer();
    return !!(d && el && d.contains(el));
  }

  window.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest || !inDrawer(t)) return;
    var row = t.closest('[data-cart-item]');
    if (!row) return;
    var rm = t.closest('[data-cart-remove]');
    var sel = t.closest('[data-quantity-selector]');
    if (!rm && !sel) return; /* edit link, title, image: untouched */
    e.preventDefault();
    e.stopPropagation();
    if (rm) { removeRow(row); return; }
    var input = row.querySelector('input[data-action-change]');
    if (!input) return;
    var step = parseInt(input.getAttribute('step'), 10) || 1;
    var cur = parseInt(input.value, 10);
    if (isNaN(cur)) cur = parseInt(input.getAttribute('data-current-qty'), 10) || 1;
    setQty(row, input, sel.hasAttribute('data-decrease-qty') ? cur - step : cur + step);
  }, true);

  window.addEventListener('change', function (e) {
    var input = e.target;
    if (!input || !input.matches || !input.matches('input[data-action-change]') || !inDrawer(input)) return;
    var row = input.closest('[data-cart-item]');
    if (!row) return;
    e.stopPropagation();
    var v = parseInt(input.value, 10);
    setQty(row, input, isNaN(v) ? 0 : v);
  }, true);

  /* Enter in a quantity box: update the line instead of submitting the drawer form */
  window.addEventListener('keydown', function (e) {
    var input = e.target;
    if (e.key !== 'Enter' || !input || !input.matches || !input.matches('input[data-action-change]') || !inDrawer(input)) return;
    e.preventDefault();
    e.stopPropagation();
    var row = input.closest('[data-cart-item]');
    var v = parseInt(input.value, 10);
    if (row) setQty(row, input, isNaN(v) ? 0 : v);
  }, true);

  window.TMCartLines = { refresh: function () { return getCart().then(function (c) { updateCounts(c); return refreshDrawer(c); }); } };
})();
